var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.burnTime)?_c('div',{staticClass:"d-flex flex-column justify-center"},[_c('p',{staticClass:"mb-0"},[_vm._v("\n    "+_vm._s(_vm.$t(`${_vm.messageTextPath}[0]`, {
        date: _vm.$d(new Date(_vm.burnTime), 'short'),
      }))+"\n  ")]),_vm._v(" "),_c('p',{staticClass:"mb-0 font-weight-bold"},[_vm._v("\n    "+_vm._s(_vm.$t(`${_vm.messageTextPath}[1]`))+"\n  ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }